import { useApiClientUser } from '~/@api/client/useApiClientUser'
import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import type {
  INotificationMarkAsReadRequest,
  INotificationMarkAsReadOkResponse,
  IUserNotificationSchema,
} from '~/@api/generated-api-types-user/Api'
import { useUser } from '~/@biz_account/useUser/useUser'

export function useUserNotifications() {
  const { user } = useUser()
  const client = useApiClientUser()
  const queryClient = useQueryClient()

  async function fetchNotifications(): Promise<Array<IUserNotificationSchema>> {
    return client.user
      .notificationsControllerList({ secure: true })
      .then((res) => res.data.items)
  }

  const {
    data: notifications,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['user-notifications'],
    queryFn: fetchNotifications,
    enabled: !!user,
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    retry: false,
  })

  async function markNotificationAsRead(
    data: INotificationMarkAsReadRequest
  ): Promise<INotificationMarkAsReadOkResponse> {
    return client.user
      .notificationsControllerMarkAsRead(data, { secure: true })
      .then((resp) => resp.data)
  }

  return {
    notifications: notifications ?? null,
    isLoading,
    isError,
    error,
    reloadNotifications: () =>
      queryClient.invalidateQueries({ queryKey: ['user-notifications'] }),
    markNotificationAsRead,
  }
}
